import { ChangeDetectionStrategy, Component, computed, inject, signal, viewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import {
  IonButton,
  IonButtons,
  IonContent,
  IonFooter,
  IonHeader,
  IonIcon,
  IonTitle,
  IonToolbar,
  ModalController,
} from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { closeOutline } from 'ionicons/icons';

import { ScreenStore } from '@core/stores/screen.store';

import { XSignaturePadComponent } from '../x-signature-pad/x-signature-pad.component';

@Component({
  selector: 'x-signature-modal',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    IonHeader,
    IonToolbar,
    IonTitle,
    IonContent,
    IonButtons,
    IonButton,
    IonFooter,
    IonIcon,
    XSignaturePadComponent,
  ],
  templateUrl: './x-signature-modal.component.html',
  styleUrl: './x-signature-modal.component.scss',
})
export class XSignatureModalComponent {
  private readonly modalCtrl = inject(ModalController);
  private readonly screenStore = inject(ScreenStore);
  private readonly signaturePad = viewChild(XSignaturePadComponent);

  label = 'Signature';
  initialValue: string | null = null;

  protected readonly signatureControl = new FormControl<string | null>(null);
  protected readonly canvasWidth = computed(() => this.screenStore.isMobile() ? 280 : 500);
  protected readonly canvasHeight = signal(200);

  constructor() {
    addIcons({ closeOutline });
  }

  onDone(): void {
    void this.modalCtrl.dismiss(this.signatureControl.value, 'confirm');
  }

  onCancel(): void {
    void this.modalCtrl.dismiss(null, 'cancel');
  }

  onClear(): void {
    this.signaturePad()?.clearSignature();
  }

  ionViewWillEnter(): void {
    this.signatureControl.setValue(this.initialValue);
  }
}
